import { takeEvery, put, call } from 'redux-saga/effects';
//Redux Actions
import CONSTANTS from '../CONSTANTS';
import { actionSetHelps } from '../actions/helpsActions';
//Services
import HelpService from '../../plugins/TS-lib-utils-public/services/HelpService';
HelpService.setBaseUrl("/translations");

/**
 * Get all helps
 */
function* sagaHelps() {
  try {
    // getKeyList resuelve a la respuesta axios; `data` es el body HTTP:
    //   { data: { pagination, keys } }
    // actionSetHelps hace `({ data }) =>` — desempaqueta ese `data` interno
    // él mismo. Por eso se le pasa el body crudo, NO desempaquetado acá.
    const { data } = yield call(HelpService.getKeyList, "web-patients", -1);
    yield put(actionSetHelps(data));
  } catch (error) {
    console.warn(error && error.message, "helpsSaga");
  }
}

export function* helpsSaga() {
  console.log('*Main Helps Saga');
  yield takeEvery(CONSTANTS.HELPS_GET, sagaHelps);
}
